import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import ProjectDetail from "./pages/ProjectDetail";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardHome from "./pages/admin/DashboardHome";
import SiteAdmin from "./pages/admin/SiteAdmin";
import AboutAdmin from "./pages/admin/AboutAdmin";
import ProjectsAdmin from "./pages/admin/ProjectsAdmin";
import ServicesAdmin from "./pages/admin/ServicesAdmin";
import TestimonialsAdmin from "./pages/admin/TestimonialsAdmin";
import MessagesAdmin from "./pages/admin/MessagesAdmin";
import AccountAdmin from "./pages/admin/AccountAdmin";
import ProtectedRoute from "./pages/admin/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/work/:slug" element={<ProjectDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardHome />} />
                <Route path="site" element={<SiteAdmin />} />
                <Route path="about" element={<AboutAdmin />} />
                <Route path="projects" element={<ProjectsAdmin />} />
                <Route path="services" element={<ServicesAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="messages" element={<MessagesAdmin />} />
                <Route path="account" element={<AccountAdmin />} />
                <Route path="*" element={<Navigate to="/admin" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster />
      </ThemeProvider>
    </div>
  );
}

export default App;
